import routeConfig from "./Config";

const routeMeta = routeConfig.reduce((acc, route) => {
    acc[route.path] = route.meta;
    return acc;
}, {});

export default routeMeta;
